import { render, staticRenderFns } from "./ym-cost-page.vue?vue&type=template&id=79d9c592&scoped=true&"
import script from "./ym-cost-page.vue?vue&type=script&lang=js&"
export * from "./ym-cost-page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79d9c592",
  null
  
)

export default component.exports